import TableContents from '../types/TableContents';

export const DSP_INTEGRATION_COMPONENT_TABLE_CONTENTS: TableContents = {
    pathName: [ '/documentation/dsp', '/documentation/dsp/integration' ],
    rightMenuNavs: [
        {
            displayName: 'Bid Request',
            hashName: '#bid-request',
            level: 1,
        },
        {
            displayName: 'Bid Response',
            hashName: '#bid-response',
            level: 1,
        },
        {
            displayName: 'Creative Types',
            hashName: '#creative-types',
            level: 1,
        },
    ]
}

export const DSP_TESTING_COMPONENT_TABLE_CONTENTS: TableContents = {
    pathName: [ '/documentation/dsp/testing' ],
    rightMenuNavs: [
        {
            displayName: 'Testing',
            hashName: '#testing',
            level: 1,
        },
        {
            displayName: 'Test App Bundle IDs',
            hashName: '#test-app-bundle-ids',
            level: 2,
        },
        {
            displayName: 'Test App Functionalities',
            hashName: '#test-app-functionalities',
            level: 2,
        },
        {
            displayName: 'Test App Instruction',
            hashName: '#test-app-instruction',
            level: 2,
        },
        {
            displayName: 'Launch',
            hashName: '#launch',
            level: 1,
        },
    ]
}

export const DSP_REPORTING_COMPONENT_TABLE_CONTENTS: TableContents = {
    pathName: [ '/documentation/dsp/reporting' ],
    rightMenuNavs: [
        {
            displayName: 'Base URL',
            hashName: '#base-url',
            level: 1,
        },
        {
            displayName: 'Example Final URL',
            hashName: '#example-final-url:',
            level: 1,
        },
        {
            displayName: 'Required Parameters',
            hashName: '#required-parameters',
            level: 2,
        },
        {
            displayName: 'Optional Parameters',
            hashName: '#optional-parameters',
            level: 2,
        },
        {
            displayName: 'Basic Reporting Columns',
            hashName: '#basic-reporting-columns',
            level: 1,
        },
        {
            displayName: 'Response Codes',
            hashName: '#response-codes',
            level: 1,
        },
    ]
}
export const DSP_CREATIVE_SPECS_COMPONENT_TABLE_CONTENTS: TableContents = {
    pathName: [ '/documentation/dsp/creative-specs' ],
    rightMenuNavs: [
        {
            displayName: 'HTML',
            hashName: '#html',
            level: 1,
        },
        {
            displayName: 'VAST',
            hashName: '#vast',
            level: 1,
        },
    ]
}
export const DSP_VIEWABILITY_COMPONENT_TABLE_CONTENTS: TableContents = {
    pathName: [ '/documentation/dsp/viewability' ],
    rightMenuNavs: [
        {
            displayName: 'Setting Up Viewability Tags',
            hashName: '#setting-up-viewability-tags',
            level: 1,
        },
        {
            displayName: 'Testing Your Viewability Tags',
            hashName: '#testing-your-viewability-tags',
            level: 1,
        },
        {
            displayName: 'Bid Responses',
            hashName: '#bid-responses',
            level: 1,
        },
        {
            displayName: 'Reporting',
            hashName: '#reporting',
            level: 1,
        },
    ]
}

export const DSP_GDPR_DELETED_DEVICE_IDS_API_COMPONENT_TABLE_CONTENTS: TableContents = {
    pathName: [ '/documentation/dsp/gdpr-deleted-device-ids-api' ],
    rightMenuNavs: [
        {
            displayName: 'GDPR Deleted Device IDs API',
            hashName: '#gdpr-deleted-device-ids-api',
            level: 1,
        },
        {
            displayName: 'Authentication',
            hashName: '#authentication',
            level: 2,
        },
        {
            displayName: 'Building the Query',
            hashName: '#building-the-query',
            level: 2,
        },
        {
            displayName: 'Query Parameters',
            hashName: '#query-parameters',
            level: 2,
        },
        {
            displayName: 'Response',
            hashName: '#response',
            level: 1,
        },
        {
            displayName: 'Errors',
            hashName: '#errors',
            level: 2,
        },
        {
            displayName: 'Example Request',
            hashName: '#example-request',
            level: 1,
        },
        {
            displayName: 'Example Response',
            hashName: '#example-response',
            level: 1,
        },
    ]
}
